export default function AnalyticsStages() {
  const stages = [
    {
      number: '1',
      icon: 'ri-search-eye-line',
      title: 'Аудит текущей аналитики',
      desc: 'Проверка корректности работы счетчиков (Яндекс.Метрика / Google Analytics 4).',
    },
    {
      number: '2',
      icon: 'ri-focus-3-line',
      title: 'Настройка целей',
      desc: 'Фиксация не просто «заходов», а конкретных действий (нажатие кнопки, заполнение формы).',
    },
    {
      number: '3',
      icon: 'ri-git-merge-line',
      title: 'Синхронизация. Связка с CRM',
      desc: 'Связка сайта, рекламных кабинетов и CRM-системы в единую экосистему.',
    },
    {
      number: '4',
      icon: 'ri-bar-chart-box-line',
      title: 'Визуализация (Дашборды)',
      desc: 'Создание понятных отчетов, где владелец бизнеса видит всё на одном экране.',
    },
  ];

  return (
    <section className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-[#1A2B4C] mb-5 font-['Playfair_Display'] leading-tight">
            Этапы внедрения
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto font-['Montserrat']">
            Систематический процесс — от проверки до результата
          </p>
        </div>

        {/* ── MOBILE TIMELINE (< lg) ── */}
        <div className="lg:hidden relative">
          {/* Vertical line */}
          <div className="absolute left-6 top-0 bottom-0 w-px bg-[#C5A880]/40"></div>

          <div className="space-y-6">
            {stages.map((stage, i) => (
              <div key={i} className="flex gap-5 items-start">
                {/* Circle */}
                <div className="relative z-10 flex-shrink-0 w-12 h-12 bg-[#1A2B4C] rounded-full flex items-center justify-center border-4 border-white shadow-md">
                  <span className="text-[#C5A880] text-base font-bold font-['Playfair_Display']">{stage.number}</span>
                </div>

                {/* Card */}
                <div className="flex-1 bg-[#F8F9FA] rounded-2xl border border-[#C5A880]/20 p-4 pb-5">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-9 h-9 bg-[#C5A880] rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className={`${stage.icon} text-lg text-white`}></i>
                    </div>
                    <h3 className="text-base font-bold text-[#1A2B4C] font-['Playfair_Display'] leading-snug">{stage.title}</h3>
                  </div>
                  <p className="text-sm text-gray-700 leading-relaxed font-['Montserrat'] text-justify pl-1">{stage.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── DESKTOP TIMELINE (>= lg) ── */}
        <div className="hidden lg:block relative">
          {/* Vertical line */}
          <div className="absolute left-1/2 top-0 bottom-0 w-px bg-[#C5A880]/30 -translate-x-1/2"></div>

          <div className="space-y-10">
            {stages.map((stage, i) => (
              <div key={i} className={`flex flex-row items-center gap-8 ${i % 2 === 1 ? 'flex-row-reverse' : ''}`}>
                {/* Card */}
                <div className="flex-1">
                  <div className="bg-[#F8F9FA] rounded-3xl border border-[#C5A880]/20 p-8 hover:shadow-lg transition-all duration-300">
                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0 w-12 h-12 bg-[#C5A880] rounded-2xl flex items-center justify-center">
                        <i className={`${stage.icon} text-2xl text-white`}></i>
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-[#1A2B4C] mb-2 font-['Playfair_Display']">{stage.title}</h3>
                        <p className="text-base text-gray-700 leading-relaxed font-['Montserrat'] text-justify">{stage.desc}</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Center circle */}
                <div className="flex-shrink-0 z-10 w-14 h-14 bg-[#1A2B4C] rounded-full flex items-center justify-center border-4 border-white shadow-lg">
                  <span className="text-[#C5A880] text-xl font-bold font-['Playfair_Display']">{stage.number}</span>
                </div>

                {/* Spacer */}
                <div className="flex-1"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Result */}
        <div className="mt-14 sm:mt-20 bg-gradient-to-r from-[#1A2B4C] to-[#243d6e] rounded-3xl p-6 sm:p-12 text-center">
          <div className="w-14 h-14 bg-[#C5A880] rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-money-dollar-circle-line text-3xl text-white"></i>
          </div>
          <h3 className="text-xl sm:text-3xl font-bold text-white mb-4 font-['Playfair_Display']">
            Экономическая выгода для вашего бизнеса
          </h3>
          <div className="max-w-3xl mx-auto mb-8 space-y-4">
            <p className="text-sm sm:text-lg text-white/85 leading-relaxed font-['Montserrat'] text-left sm:text-justify">
              Вы будете точно знать, сколько копеек прибыли приносит каждый вложенный в рекламу рубль.
            </p>
            <p className="text-sm sm:text-lg text-white/85 leading-relaxed font-['Montserrat'] text-left sm:text-justify">
              Переходите от интуитивных догадок к точным маркетинговым данным.
            </p>
          </div>
          <a
            href="#analytics-lead-form"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#C5A880] hover:bg-[#B39770] text-white px-7 sm:px-10 py-4 rounded-full text-sm sm:text-base font-semibold transition-all duration-300 hover:scale-105 cursor-pointer font-['Montserrat'] whitespace-nowrap"
          >
            <i className="ri-arrow-right-line text-xl flex-shrink-0"></i>
            Получить план оцифровки бизнеса
          </a>
        </div>
      </div>
    </section>
  );
}
